import type { InboundReceipt } from "./inboundApi";

export function inboundReceiptMatchesArrivalPackage(
  receipt: InboundReceipt,
  arrivalPackageId: string | null,
): boolean {
  if (arrivalPackageId == null || arrivalPackageId.trim() === "") {
    return receipt.inbound_arrival_package_id == null || receipt.inbound_arrival_package_id === "";
  }
  if (receipt.inbound_arrival_package_id === arrivalPackageId) {
    return true;
  }
  return (receipt.arrival_packages ?? []).some((row) => row.package_id === arrivalPackageId);
}

export function isInboundReceiptReadOnly(status: InboundReceipt["status"]): boolean {
  return status === "submitted" || status === "posted_to_mv";
}

export type InboundReceiptForPackageView = {
  receipt: InboundReceipt;
  readOnly: boolean;
};

/** Draft receipt for active counting; otherwise the latest submitted receipt for this crate. */
export function resolveInboundReceiptForArrivalPackage(
  receipts: readonly InboundReceipt[],
  arrivalPackageId: string | null,
  preferredReceiptId?: string | null,
): InboundReceiptForPackageView | null {
  const matching = receipts.filter((receipt) => inboundReceiptMatchesArrivalPackage(receipt, arrivalPackageId));

  const preferredId = preferredReceiptId?.trim() ?? "";
  if (preferredId !== "") {
    const preferred =
      matching.find((receipt) => receipt.id === preferredId)
      ?? receipts.find((receipt) => receipt.id === preferredId);
    if (preferred != null) {
      return { receipt: preferred, readOnly: isInboundReceiptReadOnly(preferred.status) };
    }
  }

  const draft =
    matching.find((receipt) => receipt.status === "draft")
    ?? (arrivalPackageId == null || arrivalPackageId === ""
      ? matching.find(
          (receipt) =>
            receipt.status === "draft"
            && (receipt.inbound_arrival_package_id == null || receipt.inbound_arrival_package_id === ""),
        )
      : null);
  if (draft != null) {
    return { receipt: draft, readOnly: false };
  }

  const submitted = matching
    .filter((receipt) => isInboundReceiptReadOnly(receipt.status))
    .sort((left, right) => right.created_at.localeCompare(left.created_at))[0];
  if (submitted != null) {
    return { receipt: submitted, readOnly: true };
  }

  return null;
}
